import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, isRef as _isRef } from "vue";
const _hoisted_1 = {
  class: "mt-20"
};
const _hoisted_2 = {
  class: "manual-test-tab"
};
const _hoisted_3 = {
  class: "filter-container"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "status-labels"
};
const _hoisted_6 = {
  class: "manual-test-tab"
};
const _hoisted_7 = {
  class: "filter-history-table-container"
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
  class: "manual-test-history-btn-group"
};
const _hoisted_10 = {
  class: "manual-test-tab"
};
const _hoisted_11 = {
  class: "manual-test-status-title"
};
const _hoisted_12 = {
  class: "test-status"
};
const _hoisted_13 = {
  class: "brief-info start-time"
};
const _hoisted_14 = {
  class: "brief-info failed-percentage"
};
const _hoisted_15 = {
  key: 0
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  class: "manual-test-detail-btn"
};
import { computed, nextTick, ref, watch } from 'vue';
import { Search } from '@element-plus/icons-vue';
import { ElTable, ElMessage, ElMessageBox } from 'element-plus';
import DialogHeader from '@/components/dialog-header/index.vue';
import ManualTestStatusIcon from './manual-test-status-icon.vue';
import { mctRequest } from '@/api/axios';
import { storeToRefs } from 'pinia';
import { useUserDefaultSettingStore } from '@/store/user';
import { useManualTestStore } from '@/store/manualTest';
import { useDetailStatusStore } from '@/store/detailStatus';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const store = useUserDefaultSettingStore();
    const {
      timeZone,
      userCEC
    } = storeToRefs(store);
    const manualTestStore = useManualTestStore();
    const {
      isShowManualTestDialog,
      manualTestDialogContentType
    } = storeToRefs(manualTestStore);
    const detailStatusStore = useDetailStatusStore();
    const {
      isShowDetailStatus,
      isManualTestDetail,
      manuelTestDetailDate
    } = storeToRefs(detailStatusStore);
    const currUserOfManualTest = ref(userCEC.value);
    const manualTestList = ref([]);
    const manualTestHistoryList = ref([]);
    const currentManualTestStatus = ref({
      testName: '',
      failServerRate: 100,
      progress: '',
      testStartTime: '',
      testStatus: '',
      manualList: []
    });
    const isSuccess = ref(false);
    const convertFractionToPercentage = value => {
      const arr = value.split('/') || [0, 0];
      const [numerator, denominator] = arr.map(item => parseInt(item));
      if (numerator === 0) {
        isSuccess.value = true;
        return 100;
      } else {
        isSuccess.value = false;
        return Math.floor(numerator / denominator * 100);
      }
    };
    const isProgressFailed = value => {
      const arr = value.split('/') || [0, 0];
      const numerator = parseInt(arr?.[0]);
      return numerator === 0;
    };
    const cachedId4ManuelTestDetail = ref(0);
    const detailOrigin = ref('');
    const showCurrentManualTestStatus = async (id, origin = '') => {
      cachedId4ManuelTestDetail.value = id;
      const config = {
        url: `test/manual-id/${id}/${timeZone.value}`,
        noLoading: true
      };
      const data = await mctRequest.request(config);
      currentManualTestStatus.value = data;
      currentManualTestStatus.value.failServerRate = convertFractionToPercentage(data.failServerRate);
      // @ts-ignore
      currentManualTestStatusTableData.value = convertToTreeStructure(data.manualList);
      manualTestDialogContentType.value = 'currentManualTestStatus';
      detailOrigin.value = origin;
    };
    const currentManualTestStatusTableData = ref([]);
    const convertToTreeStructure = list => {
      const res = [];
      let currCluster = null;
      let currZone = null;
      for (const item of list) {
        switch (item.typeId) {
          case 0:
            // Cluster
            currCluster = {
              ...item,
              children: []
            };
            res.push(currCluster);
            break;
          case 2:
            // Zone
            currZone = {
              ...item,
              children: []
            };
            if (currCluster) {
              currCluster.children.push(currZone);
            } else {
              res.push(currZone);
            }
            break;
          case 3:
            // Zone's Child
            if (currZone) {
              currZone.children.push(item);
            } else {
              res.push(item);
            }
            break;
          default:
            console.warn(`Unhandled typeId: ${item.typeId}`);
            break;
        }
      }
      return res;
    };
    const showManuelTestDetailDialog = rowData => {
      // console.log('rowData', rowData)
      if (['Init', 'Running'].includes(rowData.result)) {
        return;
      }
      const dot = {
        statusFail: true,
        zoneType: rowData.zoneType,
        serverStatus: rowData.status,
        serverId: rowData.serverId,
        statusId: rowData.manualId,
        statusFlag: 1,
        serverType: rowData.serverType
      };
      isManualTestDetail.value = true;
      manuelTestDetailDate.value = dot;
      isShowDetailStatus.value = true;
    };
    const searchByUserVal = ref('');
    const changeUserOfManualTest = userName => {
      searchByUserVal.value = userName;
      currUserOfManualTest.value = userName;
      getManualTestList();
    };
    const filterManualTest = ref('');
    const computedManualTestList = computed(() => manualTestList.value.filter(data => !filterManualTest.value || data?.name.toLowerCase().includes(filterManualTest.value.toLowerCase())));
    const showManualTestHistory = () => {
      manualTestDialogContentType.value = 'manualTestListHistory';
      getManualTestList();
    };
    const getManualTestList = async () => {
      // to get last 5 data when theAmountOfList is 5, get all history when theAmountOfList is 0
      const isManualTestHistory = manualTestDialogContentType.value === 'manualTestListHistory';
      const theAmountOfList = isManualTestHistory ? '0' : '5';
      const config = {
        url: `/test/user/${currUserOfManualTest.value}/${theAmountOfList}/${timeZone.value}`,
        noLoading: true
      };
      const {
        manualList
      } = await mctRequest.request(config);
      const res = manualList.map(manualTest => {
        let location = 'UNASSIGNED';
        if (manualTest.agent === 'INTERNAL') {
          if (manualTest.status === 0) {
            location = 'UNASSIGNED';
          } else {
            location = 'ASSIGNED';
          }
        } else {
          location = manualTest.agent;
        }
        return {
          name: manualTest.name,
          userName: manualTest.userName,
          startTime: manualTest.startTime,
          endTime: manualTest.endTime,
          status: manualTest.status,
          id: manualTest.id,
          location
        };
      });
      if (isManualTestHistory) {
        manualTestHistoryList.value = res;
      } else {
        manualTestList.value = res;
      }
    };
    const manualTestListHistoryRef = ref();
    const deleteSelectedManualTest = () => {
      ElMessageBox.confirm('The selected manual test(s) will be permanently deleted. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        ElMessage({
          type: 'success',
          message: 'Delete completed'
        });
        const manualIds = [];
        multipleSelection.value.map(item => {
          manualIds.push(item.id);
        });
        const config = {
          url: `/test/manual-id/${manualIds.join()}`,
          method: 'delete'
        };
        mctRequest.request(config);
        getManualTestList();
      }).catch(() => {
        ElMessage({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    };
    const multipleSelection = ref([]);
    const handleSelectionChange = val => {
      multipleSelection.value = val;
    };
    const returnToManualTest = prevType => {
      manualTestDialogContentType.value = prevType;
    };
    const filterManualTestHistory = ref('');
    const computedManualTestHistoryList = computed(() => manualTestHistoryList.value.filter(data => !filterManualTestHistory.value || data?.name.toLowerCase().includes(filterManualTestHistory.value.toLowerCase())).slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value));
    const currentPage = ref(1);
    const pageSize = ref(10);
    const itemNumber = computed(() => manualTestHistoryList.value?.length);
    const handleSizeChange = val => {
      pageSize.value = val;
    };
    const changeIcon = ref(true);
    const handleCurrentChange = async () => {
      changeIcon.value = false;
      await nextTick();
      changeIcon.value = true;
    };
    watch(manualTestDialogContentType, () => {
      if (['manualTestList'].includes(manualTestDialogContentType.value)) {
        getManualTestList();
      }
    });
    let intervalIndex;
    watch(() => isShowManualTestDialog.value, () => {
      if (isShowManualTestDialog.value) {
        manualTestDialogContentType.value = 'manualTestList';
        changeUserOfManualTest(userCEC.value);
        intervalIndex = setInterval(() => {
          if (['manualTestList'].includes(manualTestDialogContentType.value)) {
            getManualTestList();
          } else if ('currentManualTestStatus' === manualTestDialogContentType.value) {
            showCurrentManualTestStatus(cachedId4ManuelTestDetail.value, detailOrigin.value);
          }
        }, 1000 * 6);
      } else {
        clearInterval(intervalIndex);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_progress = _resolveComponent("el-progress");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(isShowManualTestDialog),
        "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => _isRef(isShowManualTestDialog) ? isShowManualTestDialog.value = $event : null),
        "show-close": false,
        width: "70%"
      }, {
        header: _withCtx(({
          close
        }) => [_createVNode(DialogHeader, {
          onClose: close,
          "header-name": 'Manual Test List' + (_unref(manualTestDialogContentType) === 'manualTestList' ? '(The last 5 records)' : ''),
          "guide-link": "aaa"
        }, null, 8, ["onClose", "header-name"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_input, {
          class: "w-50 m-2",
          placeholder: "Search by user name",
          "prefix-icon": _unref(Search),
          modelValue: searchByUserVal.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchByUserVal.value = $event),
          onKeyup: _cache[1] || (_cache[1] = _withKeys($event => changeUserOfManualTest(searchByUserVal.value), ["enter"]))
        }, null, 8, ["prefix-icon", "modelValue"]), _createVNode(_component_el_button, {
          class: "filter-btn",
          size: "small",
          type: "primary",
          round: "",
          onClick: _cache[2] || (_cache[2] = $event => changeUserOfManualTest('cdp_svta'))
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [_createTextVNode(" CDP SVTA ")])),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "filter-btn",
          size: "small",
          type: "primary",
          round: "",
          onClick: _cache[3] || (_cache[3] = $event => changeUserOfManualTest('PA_Auto'))
        }, {
          default: _withCtx(() => _cache[14] || (_cache[14] = [_createTextVNode(" PA Automation ")])),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "filter-btn",
          size: "small",
          type: "primary",
          round: "",
          onClick: _cache[4] || (_cache[4] = $event => changeUserOfManualTest('ChangeDashboard'))
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode(" Change Dashboard ")])),
          _: 1
        }), _createVNode(_component_el_button, {
          class: "filter-btn",
          size: "small",
          type: "primary",
          round: "",
          onClick: _cache[5] || (_cache[5] = $event => changeUserOfManualTest('mct_platform'))
        }, {
          default: _withCtx(() => _cache[16] || (_cache[16] = [_createTextVNode(" Default User ")])),
          _: 1
        }), _createVNode(_component_el_input, {
          class: "w-50 m-2 filter-table",
          placeholder: "Filter by name",
          modelValue: filterManualTest.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => filterManualTest.value = $event),
          "prefix-icon": _unref(Search)
        }, null, 8, ["modelValue", "prefix-icon"])]), _createVNode(_unref(ElTable), {
          "row-key": "date",
          data: computedManualTestList.value,
          style: {
            "width": "99%",
            "min-height": "350px"
          },
          "table-layout": "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            id: "id",
            label: "Name",
            width: "280"
          }, {
            default: _withCtx(scope => [_createElementVNode("button", {
              class: "mct-blue",
              onClick: $event => showCurrentManualTestStatus(scope.row.id, 'manualTestList')
            }, _toDisplayString(scope.row.name), 9, _hoisted_4)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "userName",
            label: "User"
          }), _createVNode(_component_el_table_column, {
            prop: "startTime",
            label: "Start Time"
          }), _createVNode(_component_el_table_column, {
            prop: "endTime",
            label: "End Time"
          }), _createVNode(_component_el_table_column, {
            prop: "status",
            label: "Status"
          }, {
            default: _withCtx(scope => [_createVNode(ManualTestStatusIcon, {
              status: scope.row.status,
              type: "manualTestList"
            }, null, 8, ["status"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "location",
            label: "Test Location",
            width: "130"
          })]),
          _: 1
        }, 8, ["data"]), _createElementVNode("div", _hoisted_5, [_createVNode(ManualTestStatusIcon, {
          "all-icons": true
        }), _createVNode(_component_el_button, {
          class: "manual-test-history",
          type: "primary",
          onClick: showManualTestHistory
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode(" Manual Test History ")])),
          _: 1
        })])], 512), [[_vShow, _unref(manualTestDialogContentType) === 'manualTestList']]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_input, {
          class: "w-50 m-2 filter-history-table",
          placeholder: "Filter by name",
          modelValue: filterManualTestHistory.value,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => filterManualTestHistory.value = $event),
          "prefix-icon": _unref(Search)
        }, null, 8, ["modelValue", "prefix-icon"])]), _createVNode(_unref(ElTable), {
          ref_key: "manualTestListHistoryRef",
          ref: manualTestListHistoryRef,
          "row-key": "date",
          data: computedManualTestHistoryList.value,
          style: {
            "width": "100%",
            "min-height": "470px"
          },
          "table-layout": "auto",
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            width: "50"
          }), _createVNode(_component_el_table_column, {
            prop: "name",
            id: "id",
            label: "Name",
            width: "280"
          }, {
            default: _withCtx(scope => [_createElementVNode("button", {
              class: "mct-blue",
              onClick: $event => showCurrentManualTestStatus(scope.row.id, 'manualTestListHistory')
            }, _toDisplayString(scope.row.name), 9, _hoisted_8)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "userName",
            label: "User"
          }), _createVNode(_component_el_table_column, {
            prop: "startTime",
            label: "Start Time"
          }), _createVNode(_component_el_table_column, {
            prop: "endTime",
            label: "End Time"
          }), _createVNode(_component_el_table_column, {
            prop: "status",
            label: "Status",
            width: "75"
          }, {
            default: _withCtx(scope => [changeIcon.value ? (_openBlock(), _createBlock(ManualTestStatusIcon, {
              key: 0,
              status: scope.row.status,
              type: "manualTestListHistory"
            }, null, 8, ["status"])) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "location",
            label: "Test Location",
            width: "130"
          })]),
          _: 1
        }, 8, ["data"]), _createVNode(_component_el_pagination, {
          "current-page": currentPage.value,
          "onUpdate:currentPage": _cache[8] || (_cache[8] = $event => currentPage.value = $event),
          "page-size": pageSize.value,
          "onUpdate:pageSize": _cache[9] || (_cache[9] = $event => pageSize.value = $event),
          "page-sizes": [10, 20, 50],
          layout: "total, sizes, prev, pager, next",
          class: "manual-test-pagination",
          total: itemNumber.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
          type: "danger",
          plain: "",
          onClick: deleteSelectedManualTest
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode(" Delete ")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = $event => returnToManualTest('manualTestList'))
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode(" Return ")])),
          _: 1
        })])], 512), [[_vShow, _unref(manualTestDialogContentType) === 'manualTestListHistory']]), _withDirectives(_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createTextVNode(" Manual Test Status For " + _toDisplayString(currentManualTestStatus.value.testName) + " ", 1), _createElementVNode("span", _hoisted_12, _toDisplayString(currentManualTestStatus.value.testStatus), 1)]), _createElementVNode("div", _hoisted_13, [_cache[20] || (_cache[20] = _createElementVNode("span", null, "Start:", -1)), _createElementVNode("span", null, _toDisplayString(currentManualTestStatus.value.testStartTime), 1), _cache[21] || (_cache[21] = _createElementVNode("span", null, "Progress:", -1)), _createElementVNode("span", null, _toDisplayString(currentManualTestStatus.value.progress), 1)]), _createElementVNode("div", _hoisted_14, [_cache[22] || (_cache[22] = _createElementVNode("span", null, "Fail Checks/All Checks:", -1)), _createVNode(_component_el_progress, {
          percentage: currentManualTestStatus.value.failServerRate,
          status: isSuccess.value ? 'success' : 'exception'
        }, null, 8, ["percentage", "status"])]), _createVNode(_unref(ElTable), {
          class: "current-manuel-test-table",
          data: currentManualTestStatusTableData.value,
          style: {
            "width": "100%",
            "margin-bottom": "20px"
          },
          "row-key": "tagID",
          border: "",
          "default-expand-all": ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name"
          }), _createVNode(_component_el_table_column, {
            prop: "type",
            label: "Type",
            width: "200"
          }), _createVNode(_component_el_table_column, {
            prop: "result",
            label: "Result",
            width: "260"
          }, {
            default: _withCtx(scope => [!/\//.test(scope.row.result) ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("span", {
              class: _normalizeClass(["show-detail-link", ['Init', 'Running'].includes(scope.row.result) ? '' : 'pointer']),
              onClick: $event => showManuelTestDetailDialog(scope.row)
            }, _toDisplayString(scope.row.result), 11, _hoisted_16)])) : (_openBlock(), _createBlock(_component_el_progress, {
              key: 1,
              percentage: convertFractionToPercentage(scope.row.result),
              status: isProgressFailed(scope.row.result) ? 'success' : 'exception'
            }, null, 8, ["percentage", "status"]))]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            prop: "status",
            label: "Status",
            width: "70"
          }, {
            default: _withCtx(scope => [_createVNode(ManualTestStatusIcon, {
              status: scope.row.status,
              type: "currentManualTestStatus"
            }, null, 8, ["status"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[11] || (_cache[11] = $event => returnToManualTest(detailOrigin.value))
        }, {
          default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode(" Return ")])),
          _: 1
        })])], 512), [[_vShow, _unref(manualTestDialogContentType) === 'currentManualTestStatus']])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});